
import React, { useState, useEffect, } from 'react';
import styled from 'styled-components';
import { GetSheetorders, Getuserprojectfromsession, Getuserworkflowfromsession, Servicecalls, SubMenuRights, convertUTCDateToLocalDate, setDateAsuserDefined, userdetails } from '../custom_functions/Functions';
import { NavLink } from 'react-router-dom';
import { isMultitenant } from '../custom_functions/Constance';
import store from '../redux_store/store';
import { withAlert } from 'react-alert';
import { withTranslation } from 'react-multi-lang';
import Service from "../custom_modules/general/Service.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { t } from 'react-multi-lang';
const StyledDashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  height: 249px;
  overflow: auto;
`;

const StyledItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;

  .time {
    font-weight: bold;
    margin-right: 10px;
  }
`;
const ELNurl = window.appUrl.ELN;
let validate_status = false;
const Activatewidgets = (props) => {
    const [activities, setActivities] = useState([]);
    const [activitychange, setActivity] = useState(false);
    const [servicecall, setServicecall] = React.useState({
        ServiceToUrl: "",
        ServiceHeaderobject: {},
        ServiceMethodType: "POST",
        ServcieonSuccess: undefined,
        ServcieonFailure: undefined,
        ServiceTenant: undefined,
        Servicecontenttype: undefined,
    });
    useEffect(() => {
        if (props?.Activatewidgets_Calldata === true || props?.Activatewidgets_Calldata === undefined) {
            (() => {
                setServicecall({
                    ServiceToUrl: "" + ELNurl + "/DashBoard/getActivewidgetsdata",
                    ServiceHeaderobject: { usercode: sessionStorage.User, lssitemaster: { sitecode: sessionStorage.Usersite } },
                    ServiceMethodType: "POST",
                    ServcieonSuccess: ActivewidgetsdataSuccess,
                    ServcieonFailure: () => { },
                    ServiceTenant: undefined,
                    Servicecontenttype: undefined,
                });
                // Servicecalls(
                //     "" + ELNurl + "/DashBoard/getActivewidgetsdata",
                //     { usercode: sessionStorage.User },
                //     ActivewidgetsdataSuccess,
                //     () => { }
                // );
                if (props.Onresetwidgetsdata !== undefined) {
                    props.Onresetwidgetsdata(false);
                }
            })()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.Activatewidgets_Calldata]);

    const OnnavelinkClicked = async (details, screenname, SendData_Child) => {
        let screen_name = screenname === "Sheet_Order" ? "/registertask" :
            screenname === "Protocol_Order" ? "/Protocolorder" :
                screenname === "Sheet_Template" ? "/sheetcreation" :
                    screenname === "Protocol_Template" ? "/protocols" : "";
        if (screen_name !== "") {
            let passobject = { screen: screen_name, name: details.Filename };
            Servicecalls(
                "" + ELNurl + "/User/getTemplateStatus",
                passobject,
                (responce) => {
                    validate_status = responce?.status === "1" ? true : false
                    if (validate_status === true) {
                        if (screen_name === "/registertask" || screen_name === "/Protocolorder") {
                            props.alert.error(
                                props.t("Dashboard.Sheetorders.IDS_MSG_RETIRED", { param: "" })
                            );
                        } else {
                            props.alert.error(
                                props.t("Dashboard.Sheettemplates.IDS_MSG_RETIRED", { param: "" })
                            );
                        }
                    }
                },
                (error) => { }
            )
        }
        let projects = Getuserprojectfromsession();
        let workflow = Getuserworkflowfromsession();
        console.log("kumu");
        if (validate_status === false && screenname === "Sheet_Order" || validate_status === false && screenname === "Protocol_Order") {
            let passdata = {};
            if (screenname === "Sheet_Order") {
                passdata = {
                    order: {
                        batchcode: details.ordercode, objLoggeduser: store.getState().Loggeduser,
                        ismultitenant: isMultitenant, lstproject: projects, lstworkflow: workflow,
                    },
                    rights: {}, user: store.getState().Loggeduser,
                    tenantid: sessionStorage.getItem("tenantid"), token: sessionStorage.getItem("Token"),
                    loginTime: sessionStorage.getItem("LoginTime"), loggedfrom: sessionStorage.getItem("loggedfrom"),
                    azuretoken: sessionStorage.getItem("azuretoken"), tenantdomain: sessionStorage.getItem("tenantdomain"),
                    screen: "Sheet",
                    multiusergroups: sessionStorage.multiusergroups,
                    packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
                    teamusercode: sessionStorage.getItem("teamusercode"),
                };
            } else if (screenname === "Protocol_Order") {
                passdata = {
                    order: {
                        protocolordercode: details.ordercode, lsuserMaster: store.getState().Loggeduser,
                        ismultitenant: isMultitenant, lstproject: projects, lstworkflow: workflow, isprotocolprocess: true,
                        copylink: true,
                    },
                    user: store.getState().Loggeduser,
                    activekey: "",
                    rights: SubMenuRights("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS"),
                    protocolorderopen: true,
                    screen: "Protocol",
                    multiusergroups: sessionStorage.multiusergroups,
                    tenantid: sessionStorage.getItem("tenantid"), token: sessionStorage.getItem("Token"),
                    loginTime: sessionStorage.getItem("LoginTime"), loggedfrom: sessionStorage.getItem("loggedfrom"),
                    azuretoken: sessionStorage.getItem("azuretoken"), tenantdomain: sessionStorage.getItem("tenantdomain"),
                    packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
                    teamusercode: sessionStorage.getItem("teamusercode"),
                    Protocol_Userworkflows: sessionStorage.getItem("Protocol_Userworkflows"),
                    userpasscodeencrypted: sessionStorage.userpasscodeencrypted,
                    idletime: sessionStorage.idletime
                };
            }

            localStorage.setItem("linkedorder", JSON.stringify(passdata));

            let orderDetails = localStorage.getItem("_viewOrderDetail");
            if (
                orderDetails !== undefined &&
                orderDetails !== null &&
                orderDetails !== ""
            ) {
                let passObj = JSON.parse(orderDetails);
                if (passObj.length > 0) {
                    passObj.map((x) => {
                        if (
                            Number(x.usercode) === Number(sessionStorage.User)
                        ) {
                            Servicecalls(
                                "" +
                                ELNurl +
                                "/File/unlockorderOnViewClose",
                                x,
                                (response) => {
                                    localStorage.setItem("_viewOrderDetail", "");
                                },
                                (response) => {
                                    localStorage.setItem("_viewOrderDetail", "");
                                }
                            );
                        }
                    });
                }
            }
        } else if (validate_status === false && screenname === "Sheet_Template" || validate_status === false && screenname === "Protocol_Template") {
            const orders = {};
            let notificationType;
            switch (screenname) {
                case "Protocol_Template":
                    orders.protocolmastercode = details.ordercode;
                    notificationType = "Protocol_Template";
                    break;
                case "Sheet_Template":
                    orders.filecode = details.ordercode;
                    orders.filenameuser = details?.Filename;
                    notificationType = "Sheet_Template";
                    break;
                default:
            }
            const passdata = {
                ...userdetails(),
                ismultitenant: isMultitenant,
                Active_Key: "1",
                screen: notificationType,
                orders: orders,
                SessionStorage_Copy: sessionStorage,
                user: store.getState().Loggeduser,
                packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
                idletime: sessionStorage.idletime
            };

            localStorage.setItem("TemplateNewtab_Open", JSON.stringify(passdata));

        } else if (screenname === "Sheet_File" || screenname === "Protocol_File") {
            localStorage.setItem("fileobj", JSON.stringify(SendData_Child));
        }

    }

    const getActivityTypeMessage = (props, screenType, activityType, Screen_Name) => {
        const activityMessages = {
            Insert: {
                Projectmaster: "IDS_AWL_NEWPROJECTADD",
                Testmaster: "IDS_AWL_NEWPROJECTADD",
                Protocol_Order: "IDS_AWL_NEWORDERREGISTER",
                Sheet_Order: "IDS_AWL_NEWORDERREGISTER",
                Sheet_Template: "IDS_AWL_NEWTEMPLATEREGISTER",
                Protocol_Template: "IDS_AWL_NEWTEMPLATEREGISTER"
            },
            Open: {
                Protocol_Order: "IDS_AWL_ORDEROPEN",
                Sheet_Order: "IDS_AWL_ORDEROPEN",
                Sheet_Template: "IDS_AWL_TEMPLATEOPEN",
                Protocol_Template: "IDS_AWL_TEMPLATEOPEN",
                Logbook: "IDS_AWL_LASTOPENLOGBOOK",
                Sheet_File: "IDS_AWL_LASTOPENFILE",
                Protocol_File: "IDS_AWL_LASTOPENFILE"
            },
            Lastopen_Folder: {
                Protocol_Folder: "IDS_AWL_LASTOPENFOLDER",
                Sheet_Folder: "IDS_AWL_LASTOPENFOLDER"
            }
        };
        return props?.props.t(`ActiveWidgets.${activityMessages[activityType][Screen_Name]}`, {
            Screen: screenType
        }) || "";
    };

    const getActivityTypeMessageElnlite = (props, screenType, activityType, Screen_Name) => {
        const activityMessages = {
            Insert: {
                Projectmaster: "IDS_AWL_NEWPROJECTADD",
                Testmaster: "IDS_AWL_NEWPROJECTADD",
                Protocol_Order: "IDS_AWL_NEWORDERREGISTERLITE",
                Sheet_Order: "IDS_AWL_NEWORDERREGISTERLITE",
                Sheet_Template: "IDS_AWL_NEWTEMPLATEREGISTER",
                Protocol_Template: "IDS_AWL_NEWTEMPLATEREGISTER"
            },
            Open: {
                Protocol_Order: "IDS_AWL_ORDEROPENLITE",
                Sheet_Order: "IDS_AWL_ORDEROPENLITE",
                Sheet_Template: "IDS_AWL_TEMPLATEOPEN",
                Protocol_Template: "IDS_AWL_TEMPLATEOPEN",
                Logbook: "IDS_AWL_LASTOPENLOGBOOK",
                Sheet_File: "IDS_AWL_LASTOPENFILE",
                Protocol_File: "IDS_AWL_LASTOPENFILE"
            },
            Lastopen_Folder: {
                Protocol_Folder: "IDS_AWL_LASTOPENFOLDER",
                Sheet_Folder: "IDS_AWL_LASTOPENFOLDER"
            }
        };
        return props?.props.t(`ActiveWidgets.${activityMessages[activityType][Screen_Name]}`, {
            Screen: screenType
        }) || "";
    };

    const getNavlinkPath = (screenname) => {
        const navlinkPaths = {
            Sheet_Order: "/vieworder",
            Protocol_Order: "/vieworder",
            Sheet_Template: "/Viewtemplate",
            Protocol_Template: "/Viewtemplate",
            Projectmaster: "/projectmaster",
            Testmaster: "/testmaster",
            Protocol_Folder: "/Protocolorder",
            Sheet_Folder: "/registertask",
            Logbook: "/logbook",
            Sheet_File: "/fileviewer",
            Protocol_File: "/fileviewer"
        };
        return navlinkPaths[screenname] || "";
    };

    const getImagePath = (screenname) => {
        const imagePaths = {
            Sheet_Order: "./images/sheet-view-blue.svg",
            Protocol_Order: "./images/sheet-view-blue.svg",
            Sheet_Template: "./images/sheet-blue.svg",
            Protocol_Template: "./images/sheet-blue.svg",
            Projectmaster: "./images/Global_Search_Folder.svg",
            Testmaster: "./images/Global_Search_Folder.svg",
            Protocol_Folder: "./images/Global_Search_Folder.svg",
            Sheet_Folder: "./images/Global_Search_Folder.svg",
            Logbook: "./images/Global_search_inventory.svg",
            Sheet_File: "./images/Global_Search_File.svg",
            Protocol_File: "./images/Global_Search_File.svg"
        };
        return imagePaths[screenname] || "";
    };

    const setColoractivity = (item) => {
        const colorMap = {
            Sheet_Order: "bluecolor",
            Protocol_Order: "oragecolor",
            Sheet_Template: "greencolor",
            Protocol_Template: "redcolor",
            Projectmaster: "graycolor",
            Testmaster: "greencolor",
            Protocol_Folder: "graycolor",
            Sheet_Folder: "oragecolor"
        };
        return colorMap[item.screenname] || "";
    };

    const ActivewidgetsdataSuccess = (response) => {
        function groupByDate(array, dateProperty) {
            return array.reduce((acc, obj) => {
                const dateKey = obj[dateProperty].toISOString().slice(0, 10);
                if (!acc[dateKey]) {
                    acc[dateKey] = [];
                }
                acc[dateKey].push(obj);
                return acc;
            }, {});
        }

        const removeDuplicates = (array) => {
            const seen = new Set();
            return array.filter(item => {
                // Extract date portion only (ignoring time)
                const dateOnly = new Date(item.activedatatimestamp).toLocaleDateString();

                let key = `${item.activewidgetsdetailscode}-${dateOnly}-${item.activityType}`;
                if (item.screenname === "Sheet_File" || item.screenname === "Protocol_File") {
                    key = `${item.description}-${dateOnly}-${item.activityType}`;
                }
                const duplicate = seen.has(key);
                seen.add(key);
                return !duplicate;
            });
        };
        const customValuesWithDates = response?.map((item) => {
            item.dateCreated = new Date(item.activedatatimestamp);
            return item;
        });
        let Original_Data = removeDuplicates(customValuesWithDates);
        const groupedData = groupByDate(Original_Data, 'dateCreated');
        const dates = Object.values(groupedData);
        let Modified_Data = dates.flatMap((items) => {
            if (items.length > 0) {
                return items.map((item, index) => {
                    if (index === 0) {
                        item.dateCreated = setDateAsuserDefined(
                            convertUTCDateToLocalDate(item.dateCreated,),
                            sessionStorage.userDefinedDate
                        )
                    } else {
                        item.dateCreated = "";
                    }
                    return item;
                });
            }
            return [];
        });
        const customizedWidgetData = Modified_Data?.map((item) => {
            let screenType;
            if (isMultitenant === 2) {
                screenType = item.screenname === "Protocol_Template" ? "Protocol" :
                    item.screenname === "Sheet_Template" ? "Sheet" :
                        item.screenname === "Sheet_Order" ? "Labsheet Tasks" :
                            item.screenname === "Protocol_Order" ? "Protocol Tasks" :
                                item.screenname.includes("Project") ? "Project" :
                                    item.screenname.includes("Logbook") ? "Logbook" : "Task";
            } else {
                screenType = item.screenname.includes("Sheet") ? "Sheet" : item.screenname.includes("Protocol") ? "Protocol" : item.screenname.includes("Project") ? "Project" : item.screenname.includes("Logbook") ? "Logbook" : "Task";
            }
            const navlinkPath = getNavlinkPath(item.screenname);
            const Imageactivity = getImagePath(item.screenname);
            const Coloractivity = setColoractivity(item);
            const ActivityData = isMultitenant === 2 ? getActivityTypeMessageElnlite(props, screenType, item.activityType, item.screenname) : getActivityTypeMessage(props, screenType, item.activityType, item.screenname);
            const SendData_Child = {
                ...(item.screenname.includes("Folder") && {
                    directorycode: item?.folderdirfloatcode !== null ? parseFloat(item.activewidgetsdetailscode + '.' + item.folderdirfloatcode) : item.activewidgetsdetailscode,
                    directoryname: item.Activewidgetsdetails,
                    parentdircode: item.parentcode,
                    path: item.description,
                    Open_Type: "Activities_Folder"
                }),
                ...(item.screenname.includes("Logbook") && {
                    logbookcode: item.activewidgetsdetailscode,
                    Open_Type: "Activities"
                }),
                ...(item.screenname.includes("Project") && { projectcode: item.activewidgetsdetailscode }),
                ...(item.screenname.includes("Test") && { testcode: item.activewidgetsdetailscode }),
                ...((item.screenname.includes("Sheet_File") || item.screenname.includes("Protocol_File")) && { tenantid: sessionStorage.getItem("tenantid"), token: sessionStorage.getItem("Token"), fileurl: item.activewidgetsdetails, uuid: item.description, filename: item.filename, Iswidgets: true })
            };
            const descriptionData = (
                <div style={{ bottom: "7px", position: "relative" }}>
                    <span className='actimages'><img src={Imageactivity} alt="Sheet View" /></span> {ActivityData}
                    {item?.cancelstatus === 1 ? <> &nbsp;#{item?.Activewidgetsdetails} </> :
                        <NavLink className="mx-2 viewDetailIcon"
                            to={{ pathname: item?.cancelstatus === 1 ? "" : navlinkPath, state: SendData_Child }}
                            onClick={() => { OnnavelinkClicked({ ordercode: item.activewidgetsdetailscode, Filename: item.Activewidgetsdetails }, item.screenname, SendData_Child) }}
                            title={"#" + item?.Activewidgetsdetails}
                            target={item?.cancelstatus === 1 ? "" : navlinkPath === "/vieworder" || navlinkPath === "/Viewtemplate" || navlinkPath === "/fileviewer" ? "_blank" : ""}
                        >
                            #{item.screenname === "Sheet_File" || item.screenname === "Protocol_File" ? item.filename : item?.Activewidgetsdetails}
                        </NavLink>
                    }

                </div>
            );

            return {
                ...item,
                Coloractivity,
                description: descriptionData,
                // dateCreated: setDateAsuserDefined(
                //     convertUTCDateToLocalDate(new Date(item.activedatatimestamp)),
                //     sessionStorage.userDefinedDate
                // ),
            };
        }).filter(item => item.description !== undefined);

        setActivities(customizedWidgetData);
        setActivity(true);
    };

    return (
        <StyledDashboard>
            <Service
                Tourl={servicecall.ServiceToUrl}
                MethodType={servicecall.ServiceMethodType}
                onSuccess={servicecall.ServcieonSuccess}
                onFailure={servicecall.ServcieonFailure}
                Headerobject={servicecall.ServiceHeaderobject}
                onReseturl={() => {
                    setServicecall({ ...servicecall, ServiceToUrl: "" });
                }}
                ServiceTenant={servicecall.ServiceTenant}
                contenttype={servicecall.Servicecontenttype}
            ></Service>

            <div className="row">
                {activitychange && activities && activities.length > 0 ? (
                    <ul className="activity-list pl-0" style={{ borderBottom: "none" }}>
                        {activities.map((activity, index) => (
                            <React.Fragment key={activity.id || index}>
                                <ActivityItem
                                    time={activity.dateCreated}
                                    description={activity.description}
                                    Coloractivity={activity.Coloractivity}
                                />
                            </React.Fragment>
                        ))}
                    </ul>
                ) : activitychange && activities && activities.length === 0 && (
                    <div className="col-lg-12 col-md-12">
                        <div className="no-data">
                            <center>
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                <div>
                                  {props.t("Dashboard.IDS_LBL_NORECFOUND")} 
                                </div>
                            </center>
                        </div>
                    </div>
                )}
            </div>
        </StyledDashboard>
    );
};

const ActivityItem = ({ time, description, Coloractivity }) => {
    return (
        <StyledItem className="newactive">
            <div className="col-lg-4 pl-0">
                <span className="time-Activities">{time}</span>
            </div>
            <div className="Activevitiesdot"><span className={`dot ${Coloractivity}`} ></span></div>
            <div className="col-lg-8 timeline-desc">
                {description}
            </div>

        </StyledItem>
    );
};

export default withAlert()(withTranslation(Activatewidgets));
